export const emptyNull = Object.create(null);
export const emptyArray = Object.freeze([]);

export const noop = () => null;
export const noopnoop = () => () => null;
export const noopTrue = () => true;
export const noopnoopTrue = () => () => true;

export const noopAsync = async () => Promise.resolve(null);
